<template>
  <div id="logo">
    <div v-if="merchant && merchant.logo">
      <img id="merchant-logo" :src="merchant.logo" />
    </div>
    <div id="merchant" v-else-if="merchant && merchant.name">
      <h4 data-cy="merchant-name">{{ merchant.name }}</h4>
    </div>
    <div v-else>
      <BlytzLogo id="blytz-logo" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { LimitedMerchant } from '@/utils/interfaces'

import BlytzLogo from '@/components/Elements/Logo/BlytzLogo.vue'

@Component({
  components: {
    BlytzLogo
  }
})
export default class Logo extends Vue {
  @Prop({ type: Object }) readonly merchant!: LimitedMerchant

  get merchantName() {
    return this.merchant.name?.substring(0, 2)
  }
}
</script>

<style lang="scss">
#logo {
  overflow: hidden;
}

#merchant {
  text-align: center;

  h4 {
    color: $white;
    margin: 0;
    text-shadow: 0 0 35px rgba(5, 22, 58, 0.76);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

#merchant-logo {
  height: 6.5vh;
  max-width: 55vw;
  object-fit: contain;
}

#blytz-logo {
  height: 6.5vh;
  max-width: 55vw;
  object-fit: contain;
}
</style>
